export default "__VITE_ASSET__C3Xbhh2U__"